import { createUri, HpQueryValue, SMap } from '@avantia/client-and-server-utilities';
import { registerConfigurationAction } from '../config/registerClientConfig';
import { setExperimentsInQuery } from '../tools/utilities';
import { HpDispatchFunction } from '../types';
import { fetchResolver } from './fetchResolver';
import {
  HpGetQuestionSetsActionProps,
  HpGetQuestionSetsActionResponse,
  HpGetQuestionSetsPayload
} from './getQuestionSetsActionTypes';

let websiteEndpoint: string;
registerConfigurationAction((config) => {
  ({ websiteEndpoint } = config);
});

export const getQuestionSetsAction: ({
  excludeProductId
}: HpGetQuestionSetsActionProps) => HpGetQuestionSetsActionResponse = ({ excludeProductId }) => {
  return (dispatch: HpDispatchFunction<HpGetQuestionSetsPayload>): Promise<void> => {
    const query: SMap<HpQueryValue> = {};
    setExperimentsInQuery(query);
    if (excludeProductId) {
      query.excludeProductIds = excludeProductId;
    }

    const url = createUri({ uri: `${websiteEndpoint}/api/questionsets`, query });
    return fetchResolver({
      options: { url, method: 'GET', description: 'Get all question sets' },
      dispatch,
      successAction: (payload) => {
        dispatch({ type: 'QUESTIONSETS_RETRIEVED', payload });
      }
    });
  };
};
